module.exports = __webpack_public_path__ + "img/hotBanner.b5c7621d.png";